var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRightChevronEp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EP_Icon_-_Right_chevron",
    "data-name": "EP Icon - Right chevron",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "chevron-nav",
    id: "Icon_ionic-ios-arrow-dropright-circle",
    "data-name": "Icon ionic-ios-arrow-dropright-circle",
    d: "M3.375,15.375a12,12,0,1,0,12-12A12,12,0,0,0,3.375,15.375Zm14.106,0L12.756,10.7a1.114,1.114,0,1,1,1.575-1.575l5.5,5.521a1.112,1.112,0,0,1,.035,1.535l-5.423,5.44a1.112,1.112,0,1,1-1.575-1.569Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#2f71ac"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightChevronEp);
export default __webpack_public_path__ + "static/media/ico-right-chevron-ep.78857cb976313663b689032bfafa473f.svg";
export { ForwardRef as ReactComponent };